import { createFileRoute } from '@tanstack/react-router'
import { useLingui } from '@lingui/react/macro'
import { SelfExclusionForm } from '@/features/self-exclusion/self-exclusion-form/self-exclusion-form'
import { TertiaryPageLayout } from '@/routes/-tertiary-page-layout'
import { AccessControlInfo } from '@/features/access-controls/access-control-info'

export const Route = createFileRoute(
  '/_app/your-play/access-controls/self-exclusion',
)({
  component: AccessControlSelect,
})

function AccessControlSelect() {
  const { t } = useLingui()

  return (
    <TertiaryPageLayout
      headerText={t`Self-exclusion`}
      infoDrawerContent={<AccessControlInfo />}
    >
      <SelfExclusionForm />
    </TertiaryPageLayout>
  )
}
